<template>
    <div class="container">
        <header-block></header-block>
        <section>
            <router-view></router-view>
        </section>
        <footer-block></footer-block>
    </div>
</template>

<script>
    import HeaderBlock from './views/Header.vue'
    import FooterBlock from './views/Footer.vue'
    export default {
        components: {
            HeaderBlock, FooterBlock
        }
    }
</script>



// WEBPACK FOOTER //
// src/App.vue